import { Injectable } from '@angular/core';



@Injectable()
export class NavigateStandardGuard  {

  //Constructor de la clase
  constructor() {
  }

  /*Necesario debido a implementacion de la interfaz CanActivate
    funcion principal del guard, verifica si se cumplen las
    condiciones para permitir la navegacion */
  canActivate() {
    return true;
  }
}
